import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';
import CheckBox from 'components/atoms/checkBox/index.jsx';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class CollapsableSelectListItemHeader extends Component {
  render() {
    const {
      title,
      name,
      checked,
      disabled,
      helpText,
      secondaryInfo,
      infoOnly,
      onClick,
      noCheckBox,
    } = this.props;
    let helpTextClasses = cx({
      helpText: true,
      inline: secondaryInfo && helpText,
    });

    if (secondaryInfo) {
      var secondaryInfoItem = <div className="secondaryInfo">{secondaryInfo}</div>;
    }
    if (helpText) {
      var helpTextItem = <div className={classnames(helpTextClasses)}>{helpText}</div>;
    }

    let className = cx({
      CollapsableSelectListItemHeader: true,
      checked: checked,
      disabled: disabled,
      infoOnly: infoOnly,
      noCheckBox: noCheckBox,
    });

    let checkBox;
    if (!infoOnly && !noCheckBox) {
      checkBox = <CheckBox name={name} checked={checked} input={{ onChange: () => {} }} />;
    }

    return (
      <div className={classnames(className)} onClick={onClick}>
        {checkBox}
        {title}
        {helpTextItem}
        {secondaryInfoItem}
      </div>
    );
  }
}
